import { todayIn, type DateOnly } from '@cfl/shared';

/*
 * "Today" for the screens, in the organisation's timezone.
 *
 * Neither `new Date().toISOString()` (UTC) nor the browser's local clock will do:
 * between 00:00 and 05:30 IST the first is still yesterday, so on the 1st every
 * month picker opened on the previous month. The zone comes with the session,
 * which loads before any signed-in screen renders; the default only covers the
 * moment before that.
 */
let zone = 'Asia/Kolkata';

export function setOrganizationTimeZone(timeZone: string): void {
  zone = timeZone;
}

export function orgToday(): DateOnly {
  return todayIn(zone);
}

/** `YYYY-MM`. */
export function orgMonth(): string {
  return orgToday().slice(0, 7);
}

export function orgYear(): number {
  return Number(orgToday().slice(0, 4));
}
